<template>
    <td>
        <select class="form-control" style="width: 180px;" v-model="data.auto_lead_type" v-if="data.auto_app_goals">
            <option value="mc">MC only</option>
            <option value="mc+direct">MC + Direct (JB+JA)</option>
            <option value="mc+ja">MC + JobAdviser (JA)</option>
            <option value="mc+driverboost">MC + DriverBoost (JA)</option>
            <option value="mc+driverboost+jb">MC + DriverBoost (JA + JB)</option>
            <option value="direct">Direct only (JB+JA)</option>
            <option value="driverboost">DriverBoost (immediate JA)</option>
            <option value="driverboost+jb">DriverBoost (JA + JB)</option>
            <option value="jobadviser">JobAdviser (JA)</option>
            <option value="uncapped_jb">Uncapped Job Board</option>
        </select>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>